import { jsx as _jsx } from "react/jsx-runtime";
import { Button } from "@faire/web--source/slate/Button";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import React from "react";
//For default case, we would show a continue with arrow for next view
//But circumstances might apply where we want to show a different text
export var ContinueToNextViewButton = function(param) {
    var className = param.className, _param_disabled = param.disabled, disabled = _param_disabled === void 0 ? false : _param_disabled, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, onClick = param.onClick, TextOverride = param.TextOverride;
    return /*#__PURE__*/ _jsx(Button, {
        onClick: onClick,
        "data-test-id": "continueButton",
        className: className,
        disabled: disabled,
        loading: isLoading,
        children: TextOverride ? TextOverride : /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "83XsId",
            defaultMessage: [
                {
                    type: 0,
                    value: "Next"
                }
            ]
        })
    });
};
